import React from "react";
import "./LoadingScreen.scss";
export default function LoadingScreen({
  fullscreen = true,
  message = "Loading",
  logoSrc = null,
  className = "",
}) {
  return (
    <div
      className={`lt-loading-root ${
        fullscreen ? "lt-fullscreen" : ""
      } ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="lt-card">
        {logoSrc ? (
          <div className="lt-logo-wrap">
            <img src={logoSrc} alt="logo" className="lt-logo" loading="lazy" />
          </div>
        ) : (
          <div className="lt-logo-sigil" aria-hidden />
        )}

        <div className="lt-body">
          <div className="lt-anim-row">
            <div className="lt-dots" aria-hidden>
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
